import {} from './types.js'

export default {
  getCursorX(state) {
    return state.cursor_x
  },
  isSuperAdmin(state) {
    return state.is_super_admin
  },
}
